import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {format} from 'date-fns';
//UI material
import {withStyles, makeStyles} from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
//DS

const StyledMenu = withStyles({
   paper: {
      border: '1px solid #d3d4d5'
   }
})((props) => (
   <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'center'
      }}
      transformOrigin={{
         vertical: 'top',
         horizontal: 'center'
      }}
      {...props}
   />
));
const useStyles = makeStyles((theme) => ({
   root: {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.secondary,
      '& svg': {
         margin: theme.spacing(1.2)
      },
      '& hr': {
         margin: theme.spacing(0, 0.5)
      }
   },
   listItem: {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(0),
      'line-height': '2px',
      '& svg': {
         margin: theme.spacing(0)
      },
      minWidth: '0px',
      minHeight: '0px',
      width: '35px'
   }
}));
function NotificacionesMenu({datos, onClickItem, tipoComponente, ...other}) {
   const [anchorEl, setAnchorEl] = useState(null);
   const [cantTotalNotificaciones, setCantTotalNotificaciones] = useState(0);
   const [tiposNotificacion, setTiposNotificacion] = useState(null);
   const classes = useStyles();
   const defaultProps = {
      color: 'secondary',
      children: <NotificationsIcon />
   };
   useEffect(() => {
      if (datos != undefined) {
         const cantidad = datos.length;
         setCantTotalNotificaciones(cantidad);
         const count = {};
         let aux;
         for (let i = 0; i < cantidad; i++) {
            aux = datos[i].tipo;
            if (count[aux]) {
               count[aux] += 1;
            } else {
               count[aux] = 1;
            }
         }
         setTiposNotificacion(count);
      }
   }, [datos]);
   const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
   };
   const handleClose = () => {
      setAnchorEl(null);
   };
   return (
      <div>
         <IconButton color="inherit" onClick={handleClick}>
            <Badge badgeContent={cantTotalNotificaciones} max={10} {...defaultProps} />
         </IconButton>
         <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            open={anchorEl !== null}
            onClose={handleClose}
         >
            {cantTotalNotificaciones > 0 &&
               cantTotalNotificaciones <= 6 &&
               datos.map((notificacion) => {
                  const nuevaFecha = new Date(notificacion.fecha);
                  const fechaLocal = format(nuevaFecha, 'yyyy-MM-dd');
                  return (
                     <div key={notificacion.id}>
                        {onClickItem[notificacion.tipo] && tipoComponente[notificacion.tipo] && (
                           <MenuItem
                              onClick={() => {
                                 onClickItem[notificacion.tipo].descomprimido(notificacion.data);
                              }}
                              className={classes.root}
                           >
                              <ListItemIcon
                                 children={tipoComponente[notificacion.tipo].icon}
                                 className={classes.listItem}
                              />
                              <Divider orientation="vertical" flexItem />
                              <ListItemText
                                 primary={notificacion.name}
                                 secondary={
                                    tipoComponente[notificacion.tipo].textSecondary +
                                    ' ' +
                                    fechaLocal
                                 }
                              />
                           </MenuItem>
                        )}
                        <Divider component="li" />
                     </div>
                  );
               })}
            {cantTotalNotificaciones > 6 &&
               Object.keys(tiposNotificacion).map((tipo) => {
                  return (
                     <div key={tipo}>
                        {onClickItem[tipo] && tipoComponente[tipo] && (
                           <MenuItem
                              onClick={() => {
                                 onClickItem[tipo].comprimido(tipo);
                              }}
                              className={classes.root}
                           >
                              <ListItemIcon
                                 children={tipoComponente[tipo].icon}
                                 className={classes.listItem}
                              />
                              <Divider orientation="vertical" flexItem />
                              <ListItemText
                                 primary={
                                    tiposNotificacion[tipo] + ' ' + tipoComponente[tipo].textPrimary
                                 }
                              />
                           </MenuItem>
                        )}
                        <Divider component="li" />
                     </div>
                  );
               })}
            {cantTotalNotificaciones === 0 && (
               <MenuItem disabled={true}>
                  <ListItemText primary="No hay notificaciones actualmente" />
               </MenuItem>
            )}
         </StyledMenu>
      </div>
   );
}
NotificacionesMenu.propTypes = {
   datos: PropTypes.array.isRequired,
   onClickItem: PropTypes.object.isRequired,
   tipoComponente: PropTypes.object.isRequired
};

export default NotificacionesMenu;
